import Layout from "./Layout.jsx";
import YearlyChart from "../components/YearlyChart.jsx";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getMe } from "../features/authSlice.js";

function YearlyChartPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => { dispatch(getMe()); }, [dispatch]);
  useEffect(() => { if (isError) navigate("/"); }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <YearlyChart />
        </Layout>
      )}
    </>
  );
}

export default YearlyChartPage;
